import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
@Component({
  selector: 'app-eap-program-info',
  templateUrl: './eap-program-info.component.html',
  styleUrls: ['./eap-program-info.component.scss']
})
export class EapProgramInfoComponent {
}